const apiConfig = {
    
        slimapi_url:"https://registrationapi.labofchoice.com/public/index.php/",
        GNS_logoURL: "https://registrationapi.labofchoice.com/public/GensysLogo/",
       
}
export default apiConfig
